import { OnboardingDetailsRole } from '@nemuru-eng/js-api-client';
import { useEffect, useState } from 'react';

import { useCheckoutSession } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useCheckoutSession';
import { LoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/entities/PaymentMethodDetail/LoanPaymentMethodDetailEntity';
import { StoredBorrowerOnboardingDetails } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/types';
import { useGetOnboardingDetailsQuery } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/hooks/useGetOnboardingDetailsQuery';
import { useOptIns } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantDataOptIn/hooks/useOptIns';
import { MerchantDataOptIn } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantDataOptIn/MerchantDataOptIn';
import { MerchantPos } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPos';

interface MerchantPosHostProps {
  opened: boolean;
  setOpened: (opened: boolean) => void;
  paymentMethodDetailEntity: LoanPaymentMethodDetailEntity;
}

export const MerchantPosDialog = ({ opened, setOpened, paymentMethodDetailEntity }: MerchantPosHostProps) => {
  const { checkoutSessionEntity, refreshCheckoutSessionAndPaymentMethodEntities } = useCheckoutSession();
  const { requiresOptIns, areOptInsChecked, waitUntilOptInConditionIsChecked, cancelWaitUntilOptInConditionChecked } =
    useOptIns(paymentMethodDetailEntity);
  const getOnboardingDetailsQuery = useGetOnboardingDetailsQuery(paymentMethodDetailEntity);

  const [optInOpened, setOptInOpened] = useState(false);

  const onboardingDetails = getOnboardingDetailsQuery.data || undefined;

  useEffect(() => {
    getOnboardingDetailsQuery.queryAsync();
  }, [paymentMethodDetailEntity]);

  if (!checkoutSessionEntity || checkoutSessionEntity.hasFinalStatus()) {
    return null;
  }

  const handleOpened = (nextOpened: boolean) => {
    if (nextOpened === false) {
      refreshCheckoutSessionAndPaymentMethodEntities();
    }
    setOpened(nextOpened);
  };

  const onSaveDetails = async (onboardingDetails: StoredBorrowerOnboardingDetails) => {
    try {
      await paymentMethodDetailEntity.createOrUpdateOnboardingDetails(onboardingDetails);
    } catch (error) {
      throw new Error(`Couldn't set onboarding details: ${error}`);
    }
  };

  const beforeSubmit = async () => {
    // FIXME: Disabled opt-ins for now
    return;

    if (!requiresOptIns) {
      return;
    }
    const areChecked = await areOptInsChecked();

    if (areChecked) {
      return;
    }

    setOptInOpened(true);
    await waitUntilOptInConditionIsChecked();
    setOptInOpened(false);
  };

  const handleOpenedOptIn = (nextOpened: boolean) => {
    if (nextOpened === false) {
      cancelWaitUntilOptInConditionChecked();
    }
    setOptInOpened(nextOpened);
  };

  const selectedRole = onboardingDetails && onboardingDetails.length > 1 ? undefined : OnboardingDetailsRole.BORROWER;

  return (
    <>
      <MerchantPos
        opened={opened}
        setOpened={handleOpened}
        checkoutSessionDetailEntity={checkoutSessionEntity}
        paymentMethodDetailEntity={paymentMethodDetailEntity}
        borrowerOnboardingDetails={onboardingDetails}
        selectedRole={selectedRole}
        onSaveDetails={onSaveDetails}
        beforeSubmit={beforeSubmit}
      />
      <MerchantDataOptIn
        opened={optInOpened}
        setOpened={handleOpenedOptIn}
        paymentMethodDetailEntity={paymentMethodDetailEntity}
      />
    </>
  );
};
